import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import {ZeitService} from '../../zeit.service';
import { addZeitFailed, addZeitStart, addZeitSucceeded } from '../actions/Zeit-add.actions';
import { loadZeitFailed, loadZeitStart, loadZeitSucceeded } from '../actions/Zeit-output.actions';
import { editZeitStart, editZeitSucceeded, editZeitFailed  } from '../actions/Zeit-edit.actions';
import { deleteZeitStart, deleteZeitSucceeded, deleteZeitFailed } from '../actions/Zeit-del.actions';
import { loadProjektFailed, loadProjektStart, loadProjektSucceeded } from '../actions/project-output.actions';
import { loadPartProjektFailed, loadPartProjektStart, loadPartProjektSucceeded } from '../actions/project-part-output.actions';
import { loadSeekFailed, loadSeekStart, loadSeekSucceeded } from '../actions/Zeit-seek.actions';
import {
  loadProjektSelectboxFailed,
  loadProjektSelectboxStart,
  loadProjektSelectboxSucceeded
} from '../actions/project-selectbox.actions';
import {
  getFilteredSeekDateFailed,
  getFilteredSeekDateStart,
  getFilteredSeekDateSucceeded
} from '../actions/filter-seek-date.actions';
import {
  setTimeToZeroFailed,
  setTimeToZeroStart,
  setTimeToZeroSucceeded
} from '../actions/setTimeToZero-edit.actions';
import {addCacheStart} from "../actions/cache-add.actions";
import {loadIstZeitFailed, loadIstZeitStart, loadIstZeitSucceeded} from '../actions/getIstZeit';
import {alleVerrechnetFailed, alleVerrechnetStart, alleVerrechnetSucceeded} from '../actions/alleVerrechnet.actions';
import {loadSaldoFailed, loadSaldoStart, loadSaldoSucceeded} from '@src/app/pages/Mitarbeiterverwaltung/store/actions/getSaldo.actions';
import {
  loadSaldoReportFailed,
  loadSaldoReportStart,
  loadSaldoReportSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getSaldoReport.actions';
import {
  getFerienReportFailed,
  getFerienReportStarted,
  getFerienReportSucceeded
} from '@src/app/pages/Zeiterfassung/store/actions/getFerienReport';

@Injectable()
export class ZeiterfassungEffects {

  /**
   * Loads the parts of the time table and lists when dispatching the start action
   */
  public loadZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadZeitStart),
      mergeMap(() =>
        this.dS.getAll().pipe(
          map((response) => loadZeitSucceeded({ item: response.data })),
          catchError((e) => of(loadZeitFailed(e))),
        ),
      ),
    ),
  );

  /* add */
  public addZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addZeitStart),
      mergeMap(() =>
        this.dS.add().pipe(
          tap((item) => sessionStorage.setItem('zeitId', item.id.toString())),
          mergeMap((response) => of(addZeitSucceeded({ item: response })
          )),
          catchError((e) => of(addZeitFailed(e))),
        ),
      ),
    ),
  );
  /*editing parts of timetable*/
  public editZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editZeitStart),
      mergeMap((ZeitStartAction) =>
        this.dS.edit(ZeitStartAction.item).pipe(
          mergeMap((response) => of(editZeitSucceeded({ item: response }), getFilteredSeekDateStart({
            string: sessionStorage.getItem('zeitFilterSearchString'),
            item: {
              datumVon: sessionStorage.getItem('zeitFilterDatumVon'),
              datumBis: sessionStorage.getItem('zeitFilterDatumBis'),
              zuverrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
              projektSuche: sessionStorage.getItem('zeitFilterPrjId'),
            }
          }),
            // INSERT CACHE
            addCacheStart({item: response}),
            )),
          catchError((e) => of(editZeitFailed(e))),
        ),
      ),
    ),
  );



  /* delets an chosen entry in table Zeit */
  public delZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteZeitStart),
      mergeMap((ZeitDeleteAction) =>
        this.dS.del(ZeitDeleteAction.item).pipe(
          mergeMap((response) => of(deleteZeitSucceeded({ item: response }), getFilteredSeekDateStart({
            string: sessionStorage.getItem('zeitFilterSearchString'),
            item: {
              datumVon: sessionStorage.getItem('zeitFilterDatumVon'),
              datumBis: sessionStorage.getItem('zeitFilterDatumBis'),
              zuverrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
              projektSuche: sessionStorage.getItem('zeitFilterPrjId'),
            }
          }))),
          catchError((e) => of(deleteZeitFailed(e))),
        ),
      ),
    ),
  );
  /* Alle Projekte Anzeigen */
  public loadProject = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProjektStart ),
      mergeMap(() =>
        this.dS.getAllProjects().pipe(
          map((response) => loadProjektSucceeded ({ projektDaten: response.data })),
          /*tap((res) => console.log(res)),*/
          catchError(() => of(loadProjektFailed())),
        ),
      ),
    ),
  );
  /* zeigt Teildaten der Projekte an */
  public loadPartProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPartProjektStart),
      mergeMap((projectAction) =>
        this.dS.box2(projectAction.item).pipe(
          mergeMap((response) => of(loadPartProjektSucceeded({ partProjektDaten: response.data }))),
          /*tap((res) => { console.log(res); } ),*/
          catchError((e) => of(loadPartProjektFailed())),
        ),
      ),
    ),
  );

  public loadSaldo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSaldoReportStart),
      mergeMap((userId) =>
        this.dS.getSaldo(userId.userId).pipe(
          map((response) => loadSaldoReportSucceeded({ item: response })),
          catchError((e) => of(loadSaldoReportFailed(e))),
        ),
      ),
    ),
  );

  /* Suchwert */
  public loadSeekValue$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSeekStart),
      mergeMap((seekAction) =>
        this.dS.seek(seekAction.iWert).pipe(
          mergeMap((response) => of(loadSeekSucceeded({ item: response.data }))),
          catchError((e) => of(loadSeekFailed(e))),
        ),
      ),
    ),
  );


  /* Such-und Datumswert nach Joel */
  public loadFilteredProjekte$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFilteredSeekDateStart),
      mergeMap((projekt) =>
        this.dS.getFilteredSeekDate(projekt.string, projekt.item).pipe(
          mergeMap((response) => of(getFilteredSeekDateSucceeded({ item: response.data}))),
          catchError((e) => of(getFilteredSeekDateFailed(e))),
        ),
      ),
    ),
  );

  /* Such-und Datumswert nach Joel */
  public loadFerienReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getFerienReportStarted),
      mergeMap((projekt) =>
        this.dS.getFerienReport(projekt.jahr, projekt.mitarbeiter).pipe(
          mergeMap((response) => of(getFerienReportSucceeded())),
          catchError((e) => of(getFerienReportFailed(e))),
        ),
      ),
    ),
  );


  public loadIstZeit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadIstZeitStart),
      mergeMap((zeit) =>
        this.dS.getIstZeit(zeit.datum).pipe(
          mergeMap((response) => of(loadIstZeitSucceeded({ zeit: response}))),
          catchError((e) => of(loadIstZeitFailed(e))),
        ),
      ),
    ),
  );

  public loadSelectboxProjects$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProjektSelectboxStart),
      mergeMap((projectAction) =>
        this.dS.getSelectboxProjects(projectAction.projektId).pipe(
          mergeMap((response) => of(loadProjektSelectboxSucceeded({ projektDaten: response.data }))),
          /*tap((res) => { console.log(res); } ),*/
          catchError((e) => of(loadProjektSelectboxFailed())),
        ),
      ),
    ),
  );

  /*editing parts of timetable*/
  public setTimeToZero$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setTimeToZeroStart),
      mergeMap((ZeitStartAction) =>
        this.dS.setTimeToZero(ZeitStartAction.zeit).pipe(
          mergeMap((response) => of(setTimeToZeroSucceeded({ item: response }), getFilteredSeekDateStart({
            string: sessionStorage.getItem('zeitFilterSearchString'),
            item: {
              datumVon: sessionStorage.getItem('zeitFilterDatumVon'),
              datumBis: sessionStorage.getItem('zeitFilterDatumBis'),
              zuverrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
              projektSuche: sessionStorage.getItem('zeitFilterPrjId'),
            }
          }))),
          catchError((e) => of(setTimeToZeroFailed(e))),
        ),
      ),
    ),
  );

  /*editing parts of timetable*/
  public setTimesToVerrechnet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(alleVerrechnetStart),
      mergeMap((ZeitStartAction) =>
        this.dS.setAlleVerrechnet(ZeitStartAction.items).pipe(
          mergeMap((response) => of(alleVerrechnetSucceeded({ items: response }), getFilteredSeekDateStart({
            string: sessionStorage.getItem('zeitFilterSearchString'),
            item: {
              datumVon: sessionStorage.getItem('zeitFilterDatumVon'),
              datumBis: sessionStorage.getItem('zeitFilterDatumBis'),
              zuverrechnen: sessionStorage.getItem('zeitFilterZuverrechnen'),
              projektSuche: sessionStorage.getItem('zeitFilterPrjId'),
            }
          }))),
          catchError((e) => of(alleVerrechnetFailed(e))),
        ),
      ),
    ),
  );

  /**
   * Constructor of Zeit effects
   *
   * @param actions$ - The action observable
   * @param dS = DummyService - The Zeit service
   */
  constructor(private actions$: Actions, private dS: ZeitService) {}
}
